import React, { useEffect, useState } from "react";
import {
  Alert,
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import { getReciversUser } from "../../services/backend/UserService";

import { pqrsdText } from "./pqrsdLabel";
// Supervisor action on a `devuelto` PQRSD. Surfaces the previous return reason
// so the new pick is informed. Server-side SLA window resets to full term.
export default function ReassignPqrsdDialog({
  open, onClose, onConfirm, busy, previousReason,
}) {
  const user = useSelector((state) => state.user.value);
  const [users, setUsers] = useState([]);
  const [pick, setPick] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!open || users.length || !user?.token) return;
    (async () => {
      const res = await getReciversUser(user.token);
      const list = Array.isArray(res) ? res : res?.users || res?.result || [];
      setUsers(Array.isArray(list) ? list : []);
    })();
  }, [open, user?.token, users.length]);

  const submit = async () => {
    if (!pick.length) {
      setError("Selecciona al menos un operario.");
      return;
    }
    try {
      setError(null);
      await onConfirm({
        toUsers: pick.map((p) => ({
          userId: p.userId,
          name: `${p.name || ""} ${p.lastName || ""}`.trim(),
          email: p.email,
        })),
      });
      setPick([]);
    } catch (e) {
      setError(e?.message || pqrsdText("No fue posible reasignar la PQRSD."));
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{pqrsdText("Reasignar PQRSD devuelta")}</DialogTitle>
      <DialogContent>
        {previousReason && (
          <Alert severity="info" sx={{ mb: 2 }}>
            <Typography variant="body2"><strong>Motivo de devolución:</strong></Typography>
            <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>{previousReason}</Typography>
          </Alert>
        )}
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Selecciona uno o varios operarios. El plazo de respuesta se reinicia al término legal completo.
        </Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Autocomplete
          multiple
          options={users}
          getOptionLabel={(o) => `${o.name || ""} ${o.lastName || ""} <${o.email || ""}>`.trim()}
          isOptionEqualToValue={(o, v) => o?.userId === v?.userId}
          value={pick}
          onChange={(_, v) => setPick(v)}
          renderInput={(params) => <TextField {...params} label="Nuevos operarios" autoFocus />}
          noOptionsText="Sin resultados"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>Cancelar</Button>
        <Button onClick={submit} variant="contained" disabled={!pick.length || busy}>Reasignar</Button>
      </DialogActions>
    </Dialog>
  );
}
